import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Splitting from 'splitting';
import gsap from 'gsap';
import 'splitting/dist/splitting.css';
import 'splitting/dist/splitting-cells.css';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // ScrollToTop functionality
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

   const mobileMenutextAnimate = () => {

    // Small delay to ensure DOM is ready
    setTimeout(() => {
      const textElements = document.querySelectorAll('.menu-text');
      if (textElements.length > 0) {
        const mobileMenuText = Splitting({
          target: ".menu-text",
          by: "chars"
        });

        console.log('Splitting result:', mobileMenuText); // Debug log

        mobileMenuText.forEach(({ chars }) => {
          if (!chars?.length) {
            console.warn('No chars found for element');
            return;
          }

          gsap.set(chars, {
            y: 0,
            x: 50,
            opacity: 0
          });

          gsap.to(chars, {
            delay: 0.3,
            y: 0,
            x: 0,
            ease: "power4.out",
            opacity: 1,
            duration: 0.9,
            stagger: {
              amount: 0.9
            }
          });
        });
      }
    }, 50);
  };


  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
    mobileMenutextAnimate();
    console.log("Menu toggled:", !isMenuOpen);
  };

  const handleLinkClick = (path) => {
    // Close mobile menu
    setTimeout(() => {
      setIsMenuOpen(false);
    }, 300);

    // Check if we're already on the target page
    if (location.pathname === path) {
      // If we're already on the page, force a reload
      window.location.reload();
    } else {
      // If we're navigating to a different page, use window.location for a full reload
      window.location.href = path;
    }
  };

  const handleLogoClick = () => {

    setTimeout(() => {
      setIsMenuOpen(false);
    }, 300);

    // Navigate to home page with full reload
    window.location.href = '/';
  };

  const isActive = (path) => {

    return location.pathname === path;
  };

  return (
    <header>
      <div className='container'>
        <div className="header_block">
          {/* Logo */}
          <div
            className="nav_brand remove-cursor"
            onClick={handleLogoClick}
          >
            <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" className="animated-logo">
              <path className="letter-r" d="M49.9998 26.91V27.0795L46.1707 27.6265L45.3396 25.6825L44.62 27.8214L40.9325 28.3278L46.7164 12.3471C47.8825 14.4479 48.91 16.7585 49.4286 19.1194C49.8908 21.2245 50.0612 23.8126 48.6971 25.6193L49.9998 26.91ZM45.8056 24.116C46.9119 23.7359 47.4814 23.2223 47.584 22.0198C47.6404 21.3609 47.612 20.6148 47.33 20.0097L45.8056 24.116Z" />
              <path className="letter-c" d="M10.5121 25.2166L7.71476 33.1113C7.63249 33.1817 6.96336 33.2537 6.80689 33.2622C2.52452 33.5041 0.444188 31.0965 0.0901154 27.0157C-0.223673 23.4039 0.288142 19.6556 1.52973 16.2616C4.17149 9.03928 10.1954 3.25759 17.566 1L14.532 9.5685C12.129 11.2185 10.1534 13.4634 8.72524 16.0015C7.58585 18.0268 5.85111 22.2721 7.59009 24.3056C7.97172 24.7517 8.84015 25.217 9.43169 25.217L10.5121 25.2166Z" />
              <path className="letter-a" d="M30.8062 30.7628L31.8044 48.9701C29.9832 49.496 28.0873 49.8044 26.188 49.857L26.1036 46.1731L24.8553 46.2596C23.9682 46.2803 23.0845 46.2083 22.2076 46.0897L20.9503 49.5638C19.1825 49.2684 17.4384 48.8049 15.7834 48.1223L21.4214 32.2437L30.8062 30.7628ZM26.0188 42.3634L25.9128 35.8008L23.3491 42.2995L25.0215 42.4075L26.0188 42.3634Z" />
              <path className="letter-y" d="M49.9141 27.7571C48.8676 36.5506 42.5761 44.5962 34.4787 48.0436C34.279 48.1288 32.7834 48.7415 32.713 48.6711L32.2949 41.9666C32.9237 41.648 33.5653 41.3586 34.1819 41.0158C34.5202 40.8276 34.8675 40.6272 35.1923 40.4166C35.2979 40.3484 35.7152 40.1005 35.7237 40.0128L32.3318 30.5092L38.5613 29.5524L40.5297 35.0387C41.8226 33.1811 42.6363 31.0261 43.177 28.8359L49.9141 27.7571Z" />
              <path className="letter-w" d="M9.02904 44.1413V39.4841L7.737 42.9557C4.76109 40.1146 2.50902 36.5456 1.23352 32.6262C1.30645 32.6071 1.31832 32.6554 1.36115 32.6889C1.57105 32.8546 1.75424 33.0499 1.98279 33.2105C3.71584 34.4279 5.88777 34.5592 7.92782 34.2342L8.03383 36.6482L8.97392 34.1579L12.6305 33.5999L12.4184 36.3511L13.4026 33.4813L20.3424 32.3931L14.8787 47.7217C14.835 47.7607 14.8007 47.7196 14.7625 47.7069C14.4394 47.6009 13.886 47.2929 13.5625 47.1264C12.4744 46.5662 11.4071 45.9061 10.4149 45.1912C9.94497 44.8527 9.49761 44.4663 9.02904 44.1413Z" />
              <path className="letter-o" fillRule="evenodd" clipRule="evenodd" d="M34.3018 16.0255C33.5105 18.5572 33.0085 21.2262 33 23.8902L33.17 26.0495L33.3702 26.8011C34.3345 30.0697 36.6026 29.6108 38.6143 27.5316C41.951 24.0825 44.7069 16.0945 44.4389 11.3378C44.1933 6.98918 41.1835 5.47607 38.0622 8.81796C36.2977 10.7069 35.0672 13.5768 34.3018 16.0255ZM39.4085 18.3343C38.8437 20.1368 38.0728 21.8703 37.0665 23.4665C37.0144 23.475 37.0183 23.4389 37.0224 23.4C37.0238 23.3871 37.0252 23.3738 37.0245 23.3618C36.9597 22.0987 37.2972 20.3453 37.5962 19.1055C38.1164 16.9471 38.9353 14.6238 40.3291 12.8827C40.38 14.7306 39.9572 16.5831 39.4085 18.3343Z" />
              <path className="letter-o-2" fillRule="evenodd" clipRule="evenodd" d="M28.7158 3.94529C28.3285 2.18205 27.4003 0.418816 25.4325 0H24.262L23.3393 0.262233C19.7664 1.54141 16.8582 6.89678 15.4784 10.137C13.3908 15.0395 11.773 21.2691 12.0261 26.6026C12.1351 28.8958 12.9874 33.1618 16.2881 32.413C18.7738 31.8489 21.2973 28.506 22.5877 26.4919C23.4136 25.2026 24.1573 23.8468 24.7825 22.4582C25.7249 20.3084 27.7208 15.4314 28.1657 13.1214C28.2336 12.7549 28.3095 12.3897 28.3854 12.0245C28.509 11.4298 28.6326 10.8349 28.7219 10.2338C29.0237 8.20584 29.1583 5.95813 28.7158 3.94529ZM17.6245 24.3507C19.4555 21.8618 20.7911 18.9721 21.8331 16.0876C22.9038 13.1226 23.7366 10.0166 23.8273 6.85553C22.5569 8.27319 21.6 10.0246 20.8267 11.7475C20.0577 13.4606 19.406 15.3051 18.8945 17.1083C18.2268 19.4621 17.7309 21.9047 17.6245 24.3507Z" />
              <path className="letter-l" d="M32.6848 1L28.393 12.9582L25.0469 22.2087L22 31L32.4633 29.4528L33.7142 25.959L33.542 23.8338L30.4097 24.1666L38 3.23609C36.3522 2.2565 34.5374 1.53421 32.6848 1Z" />
            </svg>
          </div>
          <h4>Colorway</h4>

          {/* Navigation */}
          <nav id="nav" className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <ul className="navbar">
              <li className="nav_item">
                <span
                  className={`nav_link remove-cursor rollover menu-text ${isActive('/about') ? 'active' : ''}`}
                  onClick={() => handleLinkClick('/about')}
                >
                  ABOUT
                </span>
              </li>
              <li className="nav_item">
                <span
                  className={`nav_link remove-cursor  rollover menu-text ${isActive('/work') ? 'active' : ''}`}
                  onClick={() => handleLinkClick('/work')}
                >
                  WORK
                </span>
              </li>
              <li className="nav_item">
                {/* <span
                  className={`nav_link remove-cursor  rollover menu-text ${isActive('/experience') ? 'active' : ''}`}
                  onClick={() => handleLinkClick('/experience')}
                >
                  EXPERIENCE
                </span> */}
              </li>
            </ul>

            <div className='header-footer-wrapper'>

              <ul className='header-footer-menu'>
                <li>
                  <span
                    className='footer-menu-link rollover menu-text'
                    onClick={() => handleLinkClick('/about')}
                  >
                    About
                  </span>
                </li>
                <li>
                  <span
                    className='footer-menu-link rollover menu-text'
                    onClick={() => handleLinkClick('/work')}
                  >
                    Work
                  </span>
                </li>
                <li>
                  <span
                    className='footer-menu-link rollover menu-text'
                    onClick={() => handleLinkClick('/experience')}
                  >
                    Experience
                  </span>
                </li>
                <li>
                  <span
                    className='footer-menu-link rollover menu-text'
                    onClick={() => handleLinkClick('#')}
                  >
                    Terms & Conditions
                  </span>
                </li>
                <li>
                  <span
                    className='footer-menu-link rollover menu-text'
                    onClick={() => handleLinkClick('#')}
                  >
                    Privacy Policy
                  </span>
                </li>
              </ul>

              <div className='header-footer-bottom'>
                <div className='menu-text'>&copy; 2025 Colorway</div>
                {/* <div>  <a href="tel:123-456-7890" className='menu-text'>123-456-7890</a></div> */}
              </div>
            </div>
          </nav>

          {/* Header Action */}
          <div className="header_action">
            {/* <a href="tel:123-456-7890">123-456-7890</a> */}
          </div>

          {/* Hamburger Menu */}
          <div
            id="toggleMenu"
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={() => toggleMenu()}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;